import Login from '../customModules/Login/component-login';
import CreatePassword from '../customModules/Common/components/Passwords-component';
import UserInfo from '../customModules/Users/component-user-info';
import UserDetails from '../customModules/Users/components/User-details-form';
import UserPassword from '../customModules/Users/components/User-password-form';
import Home from '../customModules/Home/component-home';
import { UsersContainer } from '../customModules/Users/containers/container-list-users';
import { AddUserContainer } from '../customModules/Users/containers/container-add-user';
import EditUserContainer from '../customModules/Users/containers/container-edit-user';
import { CompaniesContainer } from '../customModules/Companies/containers/container-list-companies';
import AddCompany from '../customModules/Companies/containers/container-add-company';
import EditCompanyContainer from '../customModules/Companies/containers/container-edit-company';
import CompanyDetails from '../customModules/Companies/component-details-company';
import CompanyInfo from '../customModules/Common/company/component-company-info';
import { PharmacyContainer } from '../customModules/Pharmacies/containers/container-list-pharmacies';
import AddPharmacy from '../customModules/Pharmacies/containers/container-add-pharmacy';
import EditPharmacy from '../customModules/Pharmacies/containers/container-edit-pharmacy';
import PharmacyDetails from '../customModules/Pharmacies/containers/container-pharmacy-details';
import AddPharmacyService from '../customModules/Pharmacies/containers/container-add-service';
import EditPharmacyService from '../customModules/Pharmacies/containers/container-edit-service';
import Statistics from '../customModules/Statistics/containers/container-list-statistics';
import { OrdersContainer } from '../customModules/Orders/containers/container-list-orders';
import OrderDetailsContainer from '../customModules/Orders/containers/container-order-details';
import { PatientsContainer } from '../customModules/Patients/containers/container-list-patients';
import { AddPatientContainer } from '../customModules/Patients/containers/container-add-patient';
import PatientDetailsContainer from '../customModules/Patients/containers/container-details-patient';
import PatientDetailsPrint  from '../customModules/Patients/components/Print-Details';
import EditPatientContainer from '../customModules/Patients/containers/container-edit-patient';

export const Pages = Object.freeze({
    LoginPage: Login,
    PasswordPage: CreatePassword,
    HomePage: Home,
    UserInfoPage: UserInfo,
    UserDetailsPage: UserDetails,
    UserPasswordPage: UserPassword,
    UsersPage: UsersContainer,
    AddUserPage: AddUserContainer,
    EditUserPage: EditUserContainer,
    CompaniesPage: CompaniesContainer,
    AddCompanyPage: AddCompany,
    EditCompanyPage: EditCompanyContainer,
    CompanyDetailsPage: CompanyDetails,
    CompanyInfoPage: CompanyInfo,
    PharmaciesPage: PharmacyContainer,
    AddPharmacyPage: AddPharmacy,
    EditPharmacyPage: EditPharmacy,
    PharmacyDetailsPage: PharmacyDetails,
    AddPharmacyServicePage: AddPharmacyService,
    EditPharmacyServicePage: EditPharmacyService,
    StatisticsPage: Statistics,
    OrdersPage: OrdersContainer,
    OrderDetailsPage: OrderDetailsContainer,
    PatientsPage: PatientsContainer,
    AddPatientPage: AddPatientContainer,
    PatientDetailsPage: PatientDetailsContainer,
    PatientPrintDetailsPage: PatientDetailsPrint,
    EditPatientPage: EditPatientContainer
});



// WEBPACK FOOTER //
// ./src/customPages/Pages.js